export default __webpack_public_path__ + "static/media/capture-stones.b03e6f74.md";